// @mui
import { Box, BoxProps } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// config
import { HEADER, NAV } from '../config-layout';
// components
import { useSettingsContext } from '../../components/settings';

// ----------------------------------------------------------------------

const SPACING = 8;

export default function Main({ children, sx, ...other }: BoxProps) {
  const { themeLayout } = useSettingsContext();

  const isNavHorizontal = themeLayout === 'horizontal';

  const isNavMini = themeLayout === 'mini';

  const isDesktop = useResponsive('up', 'lg');

  if (isNavHorizontal) {
    return (
      <Box
        component="main"
        sx={{
          pt: `${HEADER.H_MOBILE}rem`,
          pb: `${HEADER.H_MOBILE}px`,
          ...(isDesktop && {
            px: 2,
            pt: `${HEADER.H_MOBILE}rem`,
            pb: `${HEADER.H_MOBILE}rem`,
          }),
        }}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: `${HEADER.H_MOBILE}rem`,
        ...(isDesktop && {
          px: 2,
          // py: `80px`,
          // py: `${HEADER.H_MOBILE}rem`,

          width: `calc(100% - ${NAV.W_VERTICAL}rem)`,
          // width: `calc(100% - ${NAV.W_VERTICAL}px)`,
          ...(isNavMini && {
            // width: `calc(100% - ${NAV.W_DASHBOARD_MINI}px)`,
            width: `calc(100% - ${NAV.W_VERTICAL}rem)`,

          }),
        }),
        ...sx,
      }}
      {...other}
    >
      {children}
    </Box>
  );
}
